import { createStyles } from "@mantine/styles";

export const useStyle = createStyles((theme) => ({
  stepContent: {
    width: "100%",
    maxWidth: "800px",
    padding: theme.spacing.lg,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.md,
    minHeight: "auto",
  },
  headinfo: {
    marginTop: "10px",
    marginLeft: "10px",
    fontSize: "14px",
    fontWeight: 400,
  },

  topDiv: {
    marginTop: "50px",
    width: "80%",
  },
  buttonDiv2: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: "0px",
    marginTop: "80px",
    gap: "40px",
  },
  buttonWrapper: {
    display: "flex",
    paddingTop: "20px",
    gap: "10px",
  },
  upload: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    alignItems: "center",
    marginBottom: "10px",
  },
}));
